import * as React from 'react'

import { Button, LazyToggleMethod } from '@factorialco/deprecated-design-system'
import { AvailableModules, Features } from 'generated/featureDefinitions'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { track, trackingEvents } from 'modules/core/lib/Tracking'

import { getFeatureParams } from 'modules/shift_management/lib/getFeatureParams'
import { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'
import { UpsellingKit } from 'modules/upselling_kit/components'

interface Props {
  feature:
    | Features.shift_management_coverage_view
    | Features.shift_management_insights_panel
    | Features.shift_management_view_options
  setIsTooltipOpen?: LazyToggleMethod
  disabled?: boolean
}

const UpgradeButton = ({ feature, setIsTooltipOpen, disabled = false }: Props) => {
  const [isModalOpen, setIsModalOpen] = React.useState(false)
  const { company } = useCurrentSession()
  const isLegacy = company.subscription.isLegacy ?? false
  const requestReason = isLegacy ? ValidReasons.MissingFeatureLegacy : ValidReasons.MissingFeature

  const featureParams = getFeatureParams({ feature })
  const { iconName, from } = featureParams

  const onClick = () => {
    track(trackingEvents.shiftManagement.requestPlanUpdate, {
      from: from,
    })

    setIsModalOpen(true)
  }

  const onClose = () => {
    if (setIsTooltipOpen) setIsTooltipOpen(false)()
    setIsModalOpen(false)
  }

  return (
    <>
      <Button type="secondary" onClick={onClick} iconName={iconName} disabled={disabled} />
      {isModalOpen && (
        <UpsellingKit.ProductModal
          isOpen={isModalOpen}
          onClose={onClose}
          requestSource={from}
          featureRequested={feature}
          moduleRequested={AvailableModules.shift_management}
          requestReason={requestReason}
          pageSource="shift_management_table_header"
        />
      )}
    </>
  )
}

export default UpgradeButton
